// Central site metadata used by SEO tags and structured data.
// Single source of truth for brand name, canonical origin, and defaults.

export const SITE = {
  name: 'JoltStats',
  url: 'https://joltstats.com',
  defaultTitle: 'JoltStats — Rocket League Esports Stats, Schedule & Live Scores',
  description:
    'Track Rocket League esports on JoltStats — live scores, match schedules, results, and player stats across RLCS, regionals, and majors.',
  ogImage: '/assets/images/hero-bg.jpg',
  logo: '/assets/images/logo.jpeg',
};

// Resolve a site-relative path to an absolute URL for canonical/OG tags.
// Pass-through if an absolute URL is already supplied.
export function absoluteUrl(path = '/') {
  if (!path) return SITE.url;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE.url}${path.startsWith('/') ? '' : '/'}${path}`;
}
